<template>
  <div>
    <b-modal
      id="addtag-modal"
      style="justify-content: space-around"
      hide-footer
      title="تگ جدید"
    >
      <b-alert variant="danger" :show="errors.length > 0">
        <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
      </b-alert>
      <b-form @submit.stop.prevent="onSubmit">
        <div>
          <b-row>
            <b-col>
              <b-form-group id="Type-gr" label="گروه تگ:" label-for="Type">
                <MDDropdown
                  v-bind:group="110"
                  v-model="Input.parent_id"
                ></MDDropdown>
              </b-form-group>
              <b-form-group id="Type-child" label="نوع تگ:" label-for="Type">
                <MDDropdown
                  :parent="Input.parent_id"
                  v-bind:group="111"
                  v-model="Input.mdid111_tag"
                ></MDDropdown>
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <b-row class="mt-3">
          <b-col>
            <b-button
              style="width: 100%"
              variant="danger"
              @click="hideAddTagModal"
              >بازگشت</b-button
            >
          </b-col>
          <b-col>
            <b-button style="width: 100%" variant="primary" @click="addTag"
              >ذخیره</b-button
            >
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<style>
.aligner {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "@/helpers/httpHelper";
import persianDate from "../../../helpers/persianDate";
import MDDropdown from "../../../components/MDDropdown";

export default {
  name: "AddTag",
  components: {
    persianDate,
    MDDropdown,
  },
  props: ["afterdone", "customer_id", "tag_id"],
  data: function () {
    return {
      Input: {
        id: 0,
        mdid111_tag: "",
        customer_id: 0,
        parent_id: 0,
      },
      errors: [],
    };
  },
  watch: {
    tag_id: function (newVal, oldVal) {
      if (newVal != null) {
        this.EditTag();
      }
      else {
         this.Input.mdid111_tag = "";
          this.Input.parent_id = "";
      }
    },
    "Input.parent_id": function (newVal, oldVal) {
    },
  },
  computed: {},
  methods: {
    hideAddTagModal: function () {
      this.$bvModal.hide("addtag-modal");
    },
    addTag(evt) {
      if (this.tag_id != null) {
        this.Input.id = this.tag_id;
      }
      if (this.customer_id != null) {
        this.Input.customer_id = this.customer_id;
      }
      httpHelper.postData("crmtags", this.Input).then((response) => {
        if (response.success) {
          this.Input.mdid111_tag = "";
          this.Input.parent_id = "";
          this.errors = [];
          this.afterdone();
          this.hideAddTagModal();
          //this.event_id = null;
        } else {
          this.errors = [];
          for (var key in response.error) {
            response.error[key].forEach((element) => {
              this.errors.push(element);
            });
          }
        }
      });
    },
    EditTag() {
      if (this.tag_id != null) {
        this.title_modal = "ویرایش تگ";
        httpHelper.getData("crmtags?id=" + this.tag_id).then((res) => {
          if (res.success && res.result !== null) {
            this.Input = res.result;
            this.Input.parent_id = res.result.tag.parent_id;
          }
        });
      } else {
        this.title_modal = "تگ جدید";
        this.Input.mdid111_tag = "";
        this.Input.parent_id = "";
        this.errors = [];
      }
    },
  },
};
</script>
